import { SalaryStructureStatus } from 'components/SalaryStructure/types';
import { SalaryStructureFormData, StructureContribution } from './types';

export const SalaryStructureComponentValueTypeLabels = {
  SALARY_STRUCTURE_COMPONENT_VALUE_TYPE_CTC: {
    label: '% of CTC',
  },
  SALARY_STRUCTURE_COMPONENT_VALUE_TYPE_BASIC: {
    label: '% of Basic',
  },
  SALARY_STRUCTURE_COMPONENT_VALUE_TYPE_FIXED: {
    label: ' Yearly amount',
  },
};

export const statusFiltersMap: Record<string, SalaryStructureStatus> = {
  all: 'SALARY_STRUCTURE_STATUS_NONE',
  active: 'SALARY_STRUCTURE_STATUS_ACTIVE',
  inactive: 'SALARY_STRUCTURE_STATUS_INACTIVE',
};

export const EMPLOYER_CONTRIBUTIONS: StructureContribution[] = [
  {
    componentId: 'pf_employer',
    contributionType: 'PF_EMPLOYER',
    name: 'PF employer contribution',
    isEnabled: false,
    percentage: 12,
    monthlyAmount: 1800,
    baseComponent: 'CTC',
  },
  {
    componentId: 'pf_edli',
    contributionType: 'PF_EDLI',
    name: 'Include PF EDLI + admin charges part of CTC',
    isEnabled: false,
    percentage: 8.33, // Default percentage
    baseComponent: 'BASIC',
    description:
      'Employer ESIC of 8.33% of Basic salary will part of CTC if added to salary structure',
  },
  {
    componentId: 'esic',
    contributionType: 'ESIC',
    name: 'Employer ESIC part of CTC',
    isEnabled: false,
    percentage: 3.25, // Default percentage
    baseComponent: 'BASIC',
    description:
      'Employer ESIC of 3.25% of Basic salary will part of CTC if added to salary structure',
  },
  {
    componentId: 'lwf',
    contributionType: 'LWF',
    name: 'Employer LWF part of CTC',
    isEnabled: false,
    percentage: 0.32, // Default percentage
    baseComponent: 'BASIC',
    description:
      'Employer ESIC of 0.32% of Basic salary will part of CTC if added to salary structure',
  },
];

export const INITIAL_FORM_DATA: SalaryStructureFormData = {
  name: '',
  description: '',
  components: {},
  componentIds: [],
  contributions: {},
  contributionIds: [],
  sampleCTC: 0,
  creationType: 'new',
  templateId: undefined,
  type: 'SALARY_STRUCTURE_TYPE_DEFAULT',
};
